import axiosInstance from "./AxiosConfig";

class WebTemplateApi {
  async CreateTemplate(data) {
    try {
      const response = await axiosInstance.post(`/webTemplate/create`, data);
      return response.data;
    } catch (error) {
      console.error(error);
    }
  }

  async GetTemplate() {
    try {
      const response = await axiosInstance.get("/webTemplate/get");
      return response.data;
    } catch (error) {
      console.error(error);
    }
  }

  async UpdateTemplate(id, data) {
    try {
      const response = await axiosInstance.put(`/webTemplate/update/${id}`);
      return response.data;
    } catch (error) {
      console.error(error);
    }
  }

  async DeleteTemplate(id) {
    try {
      const response = await axiosInstance.delete(`/webTemplate/delete/${id}`);
      return response.data;
    } catch (error) {
      console.error(error);
    }
  }

  async GetImage(id) {
    const response = await axiosInstance.get(`/webTemplate/image/${id}`, {
      responseType: "blob",
    });
    return URL.createObjectURL(response.data);
  }




}

export default new WebTemplateApi();
